import { hash } from 'bcryptjs';
import { createContext } from 'react';
import type { AnalyticsTrackType, ProductKeysType } from '../model';

export const hashEmail = async (email: string) => {
  const salt = '$2b$11$wgr1TJNVKwiK/dQBd3HKm.';
  if (!email || typeof email === 'number') {
    return Promise.resolve('');
  }

  // set email to lowercase, split username & domain
  // tslint:disable-next-line: prefer-const
  const [username, domain] = email.toLowerCase().split('@');
  // strip fullstops
  let sanitizedUsername = username.replace(/\./g, '');
  // ignore anything after '+' char
  if (sanitizedUsername.includes('+')) {
    sanitizedUsername = sanitizedUsername.split('+')[0];
  }
  // rejoin the email
  const cleanEmail = sanitizedUsername + '@' + domain;
  const hashResult = await hash(cleanEmail, salt).catch(() => '');

  return Promise.resolve(hashResult);
};

const MarieSchema = {
  eventContainer: '',
  productKey: [],

  productEdition: '',
  productPlatform: '',
  schemaVersion: 1,

  loginUserDetected: 0,
  suiteName: '',
  // tslint:disable-next-line:no-empty
  setSuiteName: () => undefined,
  userEmail: '',
  // tslint:disable-next-line:no-empty
  setUserEmail: () => undefined,

  productsOffered: []
};
export type MarieSchemaAnalyticsType = {
  readonly eventContainer: string;
  readonly setEventContainer?: (value: string) => void;

  readonly productKey: ProductKeysType[];
  readonly productEdition: string;
  readonly productPlatform: string;
  readonly schemaVersion: number;

  readonly loginUserDetected: number;
  readonly suiteName: string;
  readonly setSuiteName: (value: string) => void;
  readonly userEmail: string;
  readonly setUserEmail: (value: string) => void;
  readonly productsOffered: string[];
  readonly analyticsTrack?: AnalyticsTrackType;
};

export const MarieSchemaAnalytics =
  createContext<MarieSchemaAnalyticsType>(MarieSchema);
